"use client";
import { Tag, Typography, Card, Button } from "antd";
import { BOM } from "../../../../../services/definedMethod";

const { Text } = Typography;

const Preview = (props) => {
  const {
    form,
    onPrevious,
    onCreateProduct,
    isCreatingProduct,
    interbankTemplate,
    interestTypeOptions,
    assetAccountOptions,
    incomeAccountOptions,
    isCreateButton,
  } = props;
  const formValues = form.getFieldsValue(true);
  console.log(formValues);
  console.log(interbankTemplate);

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const data = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Code",
          value: formValues.productCode || "--",
        },
        {
          name: "Product Name",
          value: formValues.productName || "--",
        },

        {
          name: "Product Category",
          value:
            interbankTemplate?.productCategories?.find(
              (item) => item.value === formValues.productCategory
            )?.text || "--",
          isTag: true,
        },
        {
          name: "Product Currency",
          value:
            interbankTemplate?.currencies?.find(
              (item) => item.code === formValues.currencyCode
            )?.displayLabel || "--",
          isTag: true,
        },
        {
          isInlineGroup: true,
          name: "Applicable Entities",
          group: [
            {
              name: "Applicable Entities",
              isTagGroup: true,
              fields: (() => {
                if (
                  !Array.isArray(formValues?.applicableEntities) ||
                  formValues?.applicableEntities.length === 0
                ) {
                  return [
                    {
                      value: "--",
                      isTag: true,
                    },
                  ];
                }

                const entityNames = formValues.applicableEntities
                  .map(
                    (entityId) =>
                      interbankTemplate?.applicableEntityOptions?.find(
                        (option) => option?.id === entityId
                      )?.name
                  )
                  .filter((name) => name !== undefined && name !== null);

                // Create individual tag fields for each entity name
                return entityNames.length > 0
                  ? entityNames.map((name) => ({
                      value: name,
                      isTag: true,
                    }))
                  : [
                      {
                        value: "--",
                        isTag: true,
                      },
                    ];
              })(),
            },
          ],
        },
        {
          name: "Accounting Classification",
          value:
            interbankTemplate?.accountingClassifications?.find(
              (item) => item.id === formValues.accountingClassification
            )?.name || "--",
          isTag: true,
        },
        {
          name: "Custodian",
          value:
            interbankTemplate?.custodians?.find(
              (item) => item.id === formValues.custodian
            )?.name || "--",
          isTag: true,
        },
        {
          name: "Start Date",
          value: BOM.DateTime(formValues.startDate, "only-date") || "--",
          type: "text",
        },
        {
          name: "End Date",
          value: BOM.DateTime(formValues.endDate, "only-date") || "--",
          type: "text",
        },
      ],
    },
    {
      section: "Terms",
      items: [
        {
          name: "Minimum Tenor",
          value: `${formValues.minTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Maximum Tenor",
          value: `${formValues.maxTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Default Tenor",
          value: `${formValues.defaultTenor} Days` || "--",
          type: "text",
        },
        {
          name: "Default Rate",
          value: `${formValues.defaultRate} %` || "--",
          type: "text",
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Rollover Option",
              isTagGroup: true,
              fields: [
                {
                  value: formValues.allowRollover ?? "-",
                  isTag: true,
                },
                {
                  value:
                    formValues.autoRollover !== undefined
                      ? formValues.autoRollover
                        ? "Auto Rollover"
                        : "Manual Rollover"
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Early Termination Allowed",
              isTagGroup: true,
              fields: [
                {
                  value: formValues.allowEarlyTermination ?? "-",
                  isTag: true,
                },
                // {
                //   value:
                //     formValues.earlyTerminationWithPenalty !== undefined
                //       ? formValues.earlyTerminationWithPenalty
                //         ? "With Penalty"
                //         : "Without Penalty"
                //       : "-",
                //   isTag: true,
                // },
                {
                  value:
                    interbankTemplate?.penaltyChargeOptions?.find(
                      (item) => item.id === formValues.redemptionCharge
                    )?.name || "--",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Placement Fee",
              isTagGroup: true,
              fields: [
                {
                  value: formValues.allowPlacementFee ?? "-",
                  isTag: true,
                },
                // {
                //   value:
                //     formValues.placementFeeWithPenalty !== undefined
                //       ? formValues.placementFeeWithPenalty
                //         ? "With Penalty"
                //         : "Without Penalty"
                //       : "-",
                //   isTag: true,
                // },
                {
                  value:
                    interbankTemplate?.penaltyChargeOptions?.find(
                      (item) => item.id === formValues.penaltyCharge
                    )?.name || "--",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Interest",
      items: [
        {
          name: "Interest Type",
          value:
            interbankTemplate?.interestTypes?.find(
              (item) => item.value === formValues.interestType
            )?.text || "--",
          isTag: true,
        },
        {
          name: "Interest Rate Type",
          value:
            interbankTemplate?.interestRateTypes?.find(
              (item) => item.value === formValues.interestRateType
            )?.text || "--",
          isTag: true,
        },
        {
          name: "Default Rate",
          value: `${formValues.defaultRate}%` || "--",
        },
        {
          name: "Interest Calculation Basis",
          value:
            interbankTemplate?.interestCalculationBasisOptions?.find(
              (item) => item.value === formValues.interestCalculationBasis
            )?.text || "--",
          isTag: true,
        },
        {
          name: "Interest Posting Type",
          value:
            interbankTemplate?.interestPostingTypes?.find(
              (item) => item.value === formValues.interestPostingType
            )?.text || "--",
          isTag: true,
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Tax Group",
              isTagGroup: true,
              fields: [
                {
                  value: formValues.allowTax ?? "-",
                  isTag: true,
                },
                {
                  value:
                    interbankTemplate?.taxGroupOptions?.find(
                      (item) => item.id === formValues.taxGroup
                    )?.name || "--",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      section: "Accounting",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Placement Initiation",
              isTagGroup: true,
              fields: [
                {
                  value: (() => {
                    if (
                      formValues.placementInitiationDebit === undefined ||
                      formValues.placementInitiationDebit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.incomeGlAccounts?.find(
                      (item) => item.id === formValues.placementInitiationDebit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
                {
                  value: (() => {
                    if (
                      formValues.placementInitiationCredit === undefined ||
                      formValues.placementInitiationCredit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.incomeGlAccounts?.find(
                      (item) => item.id === formValues.placementInitiationCredit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest Accrual",
              isTagGroup: true,
              fields: [
                {
                  value: (() => {
                    if (
                      formValues.interestAccrualDebit === undefined ||
                      formValues.interestAccrualDebit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.assetGLAccounts?.find(
                      (item) => item.id === formValues.interestAccrualDebit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
                {
                  value: (() => {
                    if (
                      formValues.interestAccrualCredit === undefined ||
                      formValues.interestAccrualCredit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.assetGLAccounts?.find(
                      (item) => item.id === formValues.interestAccrualCredit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest Settlement (Maturity)",
              isTagGroup: true,
              fields: [
                {
                  value: (() => {
                    if (
                      formValues.interestSettlementDebit === undefined ||
                      formValues.interestSettlementDebit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.assetGLAccounts?.find(
                      (item) => item.id === formValues.interestSettlementDebit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
                {
                  value: (() => {
                    if (
                      formValues.interestSettlementCredit === undefined ||
                      formValues.interestSettlementCredit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.assetGLAccounts?.find(
                      (item) => item.id === formValues.interestSettlementCredit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Principal Redemption",
              isTagGroup: true,
              fields: [
                {
                  value: (() => {
                    if (
                      formValues.principalRedemptionDebit === undefined ||
                      formValues.principalRedemptionDebit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.incomeGlAccounts?.find(
                      (item) => item.id === formValues.principalRedemptionDebit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
                {
                  value: (() => {
                    if (
                      formValues.principalRedemptionCredit === undefined ||
                      formValues.principalRedemptionCredit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.incomeGlAccounts?.find(
                      (item) => item.id === formValues.principalRedemptionCredit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Interest GL Posting",
              isTagGroup: true,
              fields: [
                {
                  value: (() => {
                    if (
                      formValues.interestGLPostingDebit === undefined ||
                      formValues.interestGLPostingDebit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.assetGLAccounts?.find(
                      (item) => item.id === formValues.interestGLPostingDebit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    // Show glCode with name in brackets if name exists
                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
                {
                  value: (() => {
                    if (
                      formValues.interestGLPostingCredit === undefined ||
                      formValues.interestGLPostingCredit === null
                    ) {
                      return "-";
                    }

                    const account = interbankTemplate?.assetGLAccounts?.find(
                      (item) => item.id === formValues.interestGLPostingCredit
                    );

                    if (!account || !account.glCode) {
                      return "-";
                    }

                    return account.name
                      ? `${account.glCode} (${account.name})`
                      : account.glCode;
                  })(),
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      section: "CounterParty Settings",
      items: [
        {
          isInlineGroup: true,
          name: "Customer Type",
          group: [
            {
              name: "Customer Type",
              isTagGroup: true,
              fields: (() => {
                if (
                  !Array.isArray(formValues?.counterpartyTypes) ||
                  formValues?.counterpartyTypes.length === 0
                ) {
                  return [
                    {
                      value: "--",
                      isTag: true,
                    },
                  ];
                }

                const entityNames = formValues.counterpartyTypes
                  .map(
                    (entityId) =>
                      interbankTemplate?.counterpartyTypeOptions?.find(
                        (option) => option?.id === entityId
                      )?.name
                  )
                  .filter((name) => name !== undefined && name !== null);

                // Create individual tag fields for each entity name
                return entityNames.length > 0
                  ? entityNames.map((name) => ({
                      value: name,
                      isTag: true,
                    }))
                  : [
                      {
                        value: "--",
                        isTag: true,
                      },
                    ];
              })(),
            },
          ],
        },
        {
          name: "KYC Requirement",
          value:
            interbankTemplate?.kycRequirementOptions?.find(
              (item) => item.id === formValues.kycRequirements
            )?.name || "--",
          isTag: true,
        },
        {
          name: "Deal Confirmation",
          value: formValues?.activateDealConfirmation ?? "-",
          isTag: true,
        },
        {
          name: "SWIFT / NIBSS Codes",
          value: formValues?.allowSwiftCode ?? "-",
          isTag: true,
        },
        {
          name: "Real Time Gross Settlement",
          value: formValues?.allowRTGS ?? "-",
          isTag: true,
        },
      ],
    },

    {
      section: "Compliance",
      items: [
        {
          name: "Central Bank Reports",
          value: (() => {
            if (
              !Array.isArray(formValues?.centralBankReports) ||
              formValues?.centralBankReports.length === 0
            ) {
              return "--";
            }

            const entityNames = formValues.centralBankReports
              .map(
                (entityId) =>
                  interbankTemplate?.centralBankReportOptions?.find(
                    (option) => option?.id === entityId
                  )?.name
              )
              .filter((name) => name !== undefined && name !== null);

            return entityNames.length > 0 ? entityNames.join(", ") : "--";
          })(),
          isTag: true,
        },
        {
          name: "Risk Limit",
          value: parseInt(formValues.riskLimit).toLocaleString() || "--",
          isTag: true,
        },
        {
          name: "Mandatory AML Screening",
          value: formValues.mandatoryAMLScreening ?? "-",

          isTag: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  padding: "16px 24px",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <Card
      style={{
        borderRadius: 20,
        width: "100%",
        margin: 0,
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        // style={{
        maxHeight: "744px",
        overflowY: "auto",
        // padding: "4px",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        // }}
        // height: `${current === forms.length - 1 ? "723px" : "100%"}`,
        // overflowY: `${current === forms.length - 1 ? "auto" : "hidden"}`,
      }}
    >
      <div style={{ width: "100%" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "700", margin: 0 }}>
          Preview
        </h1>
        <p
          style={{
            color: "#6b7280",
            fontWeight: "400",
            marginBottom: "24px",
            marginTop: 0,
          }}
        >
          Add description text to note for users
        </p>

        {data.map((section, sectionIndex) => (
          <div key={section.section}>
            <h2
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                marginBottom: "16px",
              }}
            >
              <div style={{ flexGrow: 1 }}> {section.section}</div>
            </h2>
            <div
              style={{
                border: "1px solid #f0f0f0",
                borderRadius: "8px",
                marginBottom: "24px",
              }}
            >
              {section.items.map((item, index) =>
                renderRow(item, index, sectionIndex)
              )}
            </div>
          </div>
        ))}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "32px",
          gap: "12px",
        }}
      >
        <Button n style={{ height: "44px" }} onClick={onPrevious}>
          Previous
        </Button>
        <Button
          type="primary"
          style={{ backgroundColor: "#9F1AB1", height: "44px" }}
          onClick={onCreateProduct}
          loading={isCreatingProduct}
        >
          {isCreateButton ? "Create product" : "Update Product"}
        </Button>
      </div>
    </Card>
  );
};

export default Preview;
